<template>
  <v-select
    :value="value"
    :items="items"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'AgUserSelect',
  props: {
    value: {
      type: [Array, String],
      default: null,
    },
    userList: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    items () {
      return this.userList.map(user => ({
        value: user.userId,
        text: `${user.firstName} ${user.lastName}`,
      }))
    },
  },
}
</script>
